import { environment } from 'apps/driver-dashboardfe/src/environments/environment';

export const InfoMessages = {
    referrals: {
        title: 'Please Note',
        message:
            'Make $25 for every referred driver! As a reminder, the number of referrals on your dashboard only includes completed referrals who are active drivers.',
    },
    earnings: {
        title: 'Please Note',
        message:
            'This includes all payments you have earned. To cash out any pending payments, visit the Payments tab.',
    },
    rewards: {
        title: 'Octopus Rewards',
        message:
            'Every 250 points earns you $25! When you complete an Uber JourneyTV trip* with your tablet, you’ll earn 1.5 points. <br/><br/><small>*Your Uber account must be linked with your Octopus account to complete Uber JourneyTV trips.</small>',
    },
    uberAuth: {
        title: 'Uber Account Linking Info',
        message: `Link your Uber Account to keep your info up to date, including your name, email address, phone number, and general account status.<br>
            <br>Steps:
            <ol>
            <li>Click the "Link My Uber Account" button</li>
            <li>Sign in using your Uber account credentials</li>
            <li>Keep an eye out for an email/text message from Uber saying your account is being accessed. This is OK since you are linking Uber with Octopus</li>
            <li>You’re all set! Your info will now remain up to date with Octopus</li>
            </ol>`,
    },
    freeze_account: {
        title: 'Account Set to Away',
        message:
            'You will not receive low activity notifications until #activationDate#. Your tablet will still log points if you drive while your account is in Away Mode.<br> Update your Back-To-Active date at any time by returning to this page. ',
    },
    fedex_return_success: {
        title: 'Success',
        message:
            'Return label sent! You will receive an email from FedEx titled, <strong>"Confirmation from FedEx Email/Online Label"</strong> soon! The email will have necessary instructions on how to use the label.',
    },
    fedex_return_error: {
        title: 'Error!',
        message: 'Please contact Play Octopus support.',
    },
    pause_account: {
        title: 'Success',
        message:
            'Thank you for pausing your account! Please check your email for more details, and reach out to our support team if you need further assistance: playoctopus.com/help',
    },
    account_reactivation_process: {
        title: 'Account Reactivation In Process',
        message:
            'ALERT: It looks like your tablet has not yet generated enough recent activity to be fully activated.<br><br>Your Octopus account has been moved to a one-week pause. This gives you time to get back on the road and generate activity with your tablet. If you are NOT able to resume driving within the next 6 days, please re-pause your account or email contact@playoctopus.com to ensure your account is not deactivated.',
    },
    account_activate: {
        title: 'Success',
        message:
            'Your Octopus account will be activated again soon! Start driving with the tablet TODAY to ensure your account remains in Good Standing.<br><br><em>Please note: Anytime when you drive with the tablet and your account is paused, you will continue to receive points!</em>',
    },
    reactivate_d60_account: {
        title: 'Account Reactivation In Process',
        message:
            'Your Octopus account has been moved to a one-week pause. This gives you time to get back on the road and generate activity with your tablet.',
    },
    address_missing: {
        title: 'Warning!',
        message: `<h6>You Entered:</h6><label> #address# </label>
                <p class="warning">Warning! We could not find any addresses that match this entry<br>Note: We cannot ship to P.O. boxes</p>`,
    },
    address_not_found: {
        title: 'Error',
        message:
            'Sorry we could not find any matching address. Please try a different address or reach out to Play Octopus Support at contact@playoctopus.com.',
    },
    update_success: {
        title: 'Success',
        message: `Successfully updated`,
    },
    has_plastic_partition: {
        class_name: 'uber-message',
        title: 'Info',
        message: `We will include the proper mounting materials for your car and tablet.`,
        is_close: true,
    },
    invalid_filetype: {
        class_name: 'uber-message',
        title: 'Error',
        message: 'Invalid file type. Please upload only images.',
        is_close: true,
    },
    food_delivery: {
        class_name: 'uber-message',
        title: 'Warning',
        message:
            'Octopus is only for use during passenger rideshare trips. Please do not use the tablet during food deliveries.',
        is_close: true,
    },
    reset: {
        class_name: 'uber-message',
        title: 'Info',
        message: `<div>
        Please check for an email from <a href="mailto:contact@playoctopus.com">contact@playoctopus.com</a> with instructions to reset your password. Check your spam / junk mail folder if you can’t find it!
        <br /><br />
        Por favor busque un correo electrónico de <a href="mailto:contact@playoctopus.com">contact@playoctopus.com</a> con instrucciones para restablecer su contraseña. ¡Revise la carpeta de spam/correo no deseado!
    </div>`,
        is_close: true,
    },
    prizeout_selected: {
        title: 'Oops',
        message:
            'One of your selected cash outs is only eligible for gift card redemption via Prizeout. Please de-select the "Prizeout only" cash out row to proceed.',
    },
};

export const UiMessageCodes: any = {
    invalid_credentials: `Oops! You entered an incorrect username or password. <br>
        Click this link to reset your password: <a href='${environment.resetUrl}'>account.playoctopus.com/reset</a>.`,
    auth_error: `Oops! You entered an incorrect username or password. <br>
        Click this link to reset your password: <a href='${environment.resetUrl}'>account.playoctopus.com/reset</a>.`,
    auth_password_error: `Oops! That password was incorrect. You have {} attempts left before your account is locked for 24 hours.
        Try again or reset your password <a href='${environment.resetUrl}'>here</a>.`,
    login_second_error: `Oops! Incorrect credentials. Your account will be locked out soon due to multiple failed login attempts.
        Please reset your password before you attempt to login again at:
        <a href='${environment.resetUrl}'>account.playoctopus.com/reset</a>.`,
    otp_error: `Oops! That security authentication code was incorrect. You have {} attempts left before your account is locked for 24 hours.
        Resend code or <a href='${environment.helpUrl}'>contact support</a> for assistance.`,
    otp_invalid: `Oops! That security authentication code was incorrect. You have {} attempts left before your account is locked for 24 hours.
        Resend code or <a href='${environment.helpUrl}'>contact support</a> for assistance.`,
    stripe_tos_success: `Thank you for accepting the payment terms of service. Your cash outs will be automatically resumed within 20 minutes.
        <br>If you have any questions or need further assistance,
        please visit <a href='${environment.helpUrl}' target='_blank'>playoctopus.com/help</a>.`,
    invalid_prepaid: ` Looks like you’re trying to add a prepaid card. Unfortunately, we can’t accept these, but you can add the bank associated with the prepaid card.
        Instructions here: <a href='${environment.helpUrl}/payment-link-error' target='_blank'>playoctopus.com/help/payment-link-error</a>.`,
    ineligible_account: `Oops! This account has been locked because you have another open Octopus account.`,
    invalid_grant: `The authorization is invalid. Please link your Uber account again.`,
    invalid_partner_data: `You cannot connect this Uber account. Please try a different account.`,
    uber_already_connected: `This Uber account is already connected to another Octopus account. Please try a different account.`,
    prizeout_unavailable: `Oops! Gift card cash outs are currently unavailable. Please cash out using a debit card instead. <br>
    Need help? Visit: <a href='${environment.helpUrl}' target='_blank'>playoctopus.com/help</a>.`,
    w9_not_submitted: `You need to provide your tax information to resume cash outs. Rhode Island requires that we file a 1099 with the state if you cash out more than $100 in a calendar year with Octopus. We will also file a 1099 with the IRS if you exceed $600 in cash outs in a calendar year. `
};
